<template>
  <div class="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
    <div class="bg-base-100 p-6 rounded-lg shadow-lg max-w-md w-full">
      <h4 class="text-lg font-semibold mb-4">Auto Fill Settings</h4>
      <div class="space-y-4">
        <div class="form-control">
          <label class="label">
            <span class="label-text">Fill Threshold (1-100):</span>
          </label>
          <input
            type="range"
            v-model="threshold"
            min="1"
            max="100"
            step="1"
            class="range range-primary"
          />
          <div class="text-center font-medium text-primary mt-2">
            {{ threshold }}%
          </div>
        </div>
        <div class="text-sm text-neutral-content">
          <p class="mb-2">
            Threshold determines how aggressively empty areas are filled:
          </p>
          <ul class="list-disc pl-5 space-y-1">
            <li>1-30: Conservative filling, only small gaps</li>
            <li>31-70: Balanced filling of medium-sized areas</li>
            <li>71-100: Aggressive filling of large empty areas</li>
          </ul>
        </div>
      </div>
      <div class="flex justify-end gap-4 mt-6">
        <button @click="confirmFill" class="btn btn-primary">Apply</button>
        <button @click="$emit('close')" class="btn">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits<{
  (e: "auto-fill", threshold: number): void;
  (e: "close"): void;
}>();

const threshold = ref(50);

const confirmFill = () => {
  if (threshold.value < 1 || threshold.value > 100) {
    alert("Please enter a threshold between 1 and 100");
    return;
  }
  emit("auto-fill", threshold.value);
};
</script>

<style scoped></style>
